export default "Time to go back to the '80s!";